// Gerado por scripts/build-tokens.mjs a partir de tokens.json. Não editar à mão.
export const TOKENS_VERSION = "1.0.0-draft";
/** Tamanhos de letra do painel de leitura (D84). */
export const FONT_SCALE_STEPS = { "A": 1, "A+": 1.15, "A++": 1.3 };
/** Abaixo de desktopMin: barra inferior; a partir dele, barra superior se couber (D64, D70). */
export const BREAKPOINTS = { mobileMax: 1023, desktopMin: 1024 };
/** Cores em hexadecimal, para conferir contraste em teste; as telas usam as variáveis CSS. */
export const COLORS = {
    "ink": "#1A1A2E",
    "ink-2": "#4B5563",
    "bg": "#FFFFFF",
    "bg-2": "#F6F7F8",
    "line": "#E5E7EB",
    "field": "#6B7280",
    "cyan": "#0E7490",
    "cyan-hover": "#155E75",
    "cyan-brand": "#06B6D4",
    "cyan-50": "#ECFEFF",
    "cyan-line": "#A5F3FC",
    "cyan-ink": "#164E63",
    "orange": "#C2410C",
    "orange-hover": "#9A3412",
    "orange-50": "#FFF7ED",
    "orange-line": "#FED7AA",
    "orange-ink": "#7C2D12",
    "success": "#047857",
    "success-50": "#D1FAE5",
    "error": "#B91C1C",
    "warning": "#B45309",
    "focus": "#0E7490"
};
export const COLORS_HIGH_CONTRAST = {
    "ink": "#000000",
    "ink-2": "#1F2937",
    "line": "#1F2937",
    "field": "#000000",
    "bg-2": "#FFFFFF",
    "cyan": "#155E75",
    "cyan-50": "#FFFFFF",
    "cyan-line": "#000000",
    "orange": "#9A3412",
    "orange-hover": "#7C2D12",
    "focus": "#000000",
    "success": "#064E3B",
    "error": "#991B1B",
    "warning": "#78350F"
};
